<template>
 <div class="container">

    <div class="modal-dialog" style="max-width:500px;">

        <div v-if="!checkUserComp" class="modal-content">
            <div class="modal-header text-center" style="padding-top:0px !important;padding-bottom:0px !important;">
                <h3 style="margin-bottom:0px;">We are excited to have you with us </h3>
            </div>

         
            <div  class="modal-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-12">
                       <div class="alert alert-danger alert-dismissible" v-if="errorMsg">
                <button  type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                <strong></strong>{{errorMsg}}
            </div>

            <div class="alert alert-success alert-dismissible" v-if="notificationMsg">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                {{notificationMsg}}
            </div>
                        <div>
                            <div>
                                <div> <a style="background-color: #4267b2;color: #fff; margin-top:5px!important;  margin: 20px auto 0px auto" class="btn btn-lg btn-title btn-block btn-social btn-facebook">
                          <span class="fa fa-facebook"></span>
                          <fb-signin-button class="text-center"
                              :params="fbSignInParams"
                              @success="onSignInSuccess"
                              @error="onSignInError">
                              Continue with Facebook
                            </fb-signin-button></a> </div>
                          
                            </div>
                        </div>
                    </div>
                </div>
                <hr style="margin-bottom:10px;">
                <p class="text-center small">Or register using your email</p>
                     <div class="row">
                    <div class="col-xs-12 col-sm-12">
                            <div class="well" style="margin-bottom:5px;">
                            <div class="form-group" style="padding-bottom:0px">
                     
             
                  
                      <div class="form-group">
                         <div class="inner-addon right-addon">
                                  <i v-show="errors.has('firstName')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('firstName')" v-if="credentials.firstName.length>2" class="fa fa-paw text-success "></i>
                              <input  type="text" name="firstName" data-vv-as="first name" v-validate="'required|min:3'" class="form-control"  :class="{'input': true, 'has-error': errors.has('firstName') }" @keyup.enter="validateBeforeSubmit()" placeholder="First Name" v-model.lazy="credentials.firstName" tabindex="1" >
                              </div>
                              <span v-show="errors.has('firstName')" class="text-danger h5">{{ errors.first('firstName') }}</span>
                            </div>
                            
                      <div class="form-group">
                        <div class="inner-addon right-addon">
                                  <i v-show="errors.has('lastName')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('lastName')" v-if="credentials.lastName.length>2" class="fa fa-paw text-success "></i>
                                <input  type="text" name="lastName" data-vv-as="last name" v-validate="'required|min:3'" class="form-control" :class="{'input': true, 'has-error': errors.has('lastName') }" @keyup.enter="validateBeforeSubmit()" placeholder="Last Name" v-model.lazy="credentials.lastName" tabindex="2" >
                                </div>
                              <span v-show="errors.has('lastName')" class="text-danger h5">{{ errors.first('lastName') }}</span>
                        </div>
                        
                      <div class="form-group">
                       <div class="inner-addon right-addon">
                                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('email')" v-if="credentials.email" class="fa fa-paw text-success "></i>
                                <input  type="email" name="email" data-vv-as="email" v-validate="'required|email'" class="form-control" :class="{'input': true, 'has-error': errors.has('email') }" @keyup.enter="validateBeforeSubmit()" placeholder="Email" v-model.lazy="credentials.email" tabindex="3" >
                                </div>
                              <span v-show="errors.has('email')" class="text-danger h5">{{ errors.first('email') }}</span>
                        </div>
                      <div class="form-group">
                           <div class="inner-addon right-addon">
                                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('password')" v-if="credentials.password" class="fa fa-paw text-success "></i>
                                    <input type="password" name="password" class="form-control" v-validate="'required|min:6'" :class="{'input': true, 'has-error': errors.has('password') }" v-model="credentials.password" @keyup.enter="validateBeforeSubmit()" placeholder="Password" tabindex="4" data-vv-delay="1500" >
                                  <span v-show="errors.has('password')" class="text-danger h5">{{ errors.first('password') }}</span>
                                  </div>
                          </div>
                          </div>
                        </div>
                        <p style="padding-left:5px;" class="small">By registering you agree to our <a href="/terms-and-conditions">terms and conditions</a></p> 
                        
                        <button class="btn btn-primary pull-right btn-title" style="margin-top:10px;" v-bind:disabled="filledRequired == false" tabindex="5"  @click="validateBeforeSubmit()">Signup</button>   
                        
                       
                        
                    
                    </div>
                     
                  </div>
                </div>
            </div>

        </div>

        <div v-if="checkUserComp && userRoleComp!='Sitter'" class="col-xs-12 col-sm-4 col-sm-offset-4">
        
        <h3 class="text-center">You already have a sitter account, click below to login as a sitter</h3>
                <button class="btn btn-info btn-block btn-title"  @click="confirmSwitchAccount()">Switch Account</button>
        </div>
        <div v-if="checkUserComp && userRoleComp=='Sitter'">
          <h3 class="text-center"> You are already logged in as a sitter </h3>
          <div class="col-xs-12 col-sm-4 col-sm-offset-4">
          <button class="btn btn-info btn-block btn-title"  @click="goDashboard()">Go to Dashboard</button>
          </div>
        </div>
    </div>

</div>
    

  
</template>

<script>


import auth from '../../auth'
import store from '../../data/store'


export default {
  data() {
    return {
      fbSignInParams: {
           scope: 'email,public_profile',
           return_scopes: true
      },
      credentials: {
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        confirmPassword: '',

             
      },
      FBTokenInfo: {
          Token: '',
          Email: '',
          Provider: 'Facebook',
          ProfilePicUrl: '',
          FirstName: '',
          LastName: '',
          CountryId: localStorage.getItem('CountryId'),
          UserRole: 'Sitter'

        },
        
        error: '',
        notification: '',
     
      
    }
  },
  updated(){
    var self = this
    this.$ga.page(this.$router)
    // $('input').focus(function (){
    //         self.scrollPosition = window.scrollY
            
    // })
    // $('input').blur(function (){
    //         // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
    //         self.$SmoothScroll(self.scrollPosition, 350)
            
    // })

    
  },
  methods: {
      goDashboard(){
                var self = this
                
                 if (self.userRoleComp=="Sitter" && localStorage.getItem('phoneConfirmed')=="False")
                {
                    
                    swal({
                        title: "Mobile needs verifcation",
                        text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
                        type: "success",
                        showCancelButton: true,
                        confirmButtonClass: 'btn-success',
                        confirmButtonText: "Yes take me there!",
                        cancelButtonText: "Later",
                        allowOutsideClick: false,
                        closeOnConfirm: true,
                        }, function(isConfirm){
                        if (isConfirm){
                        self.$router.push({path: '/account', force: true})
                        return;
                        } else {
                        self.$router.push({path: '/dashboard/feedback-performance',force: true})
                        }
                    });
                } else {
                    self.$router.push({path: '/dashboard/feedback-performance',force: true})
                }
                
            },
      confirmSwitchAccount(){
        var self = this
           swal({
              title: "Switch Account Confirmation",
              text: "You are currently logged in as " + self.userRoleComp + " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " + self.userRoleComp + " anytime",
              type: "info",
              showCancelButton: true,
              confirmButtonClass: 'btn-success',
              confirmButtonText: "Yes, switch account",
              closeOnConfirm: true,
              html: true
            }, function(){
              self.switchAccount()
            });
            
      },
      switchAccount(){
        var self = this
        $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/api/account/SwitchRole/' + self.countryDataComp.CountryId,
            contentType: "application/json; charset=utf-8",
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert  = data
                    auth.logout()
                    self.$router.push({path: '/login', query: {switch: 'yes'}})
                    // router.go({path: '/login', query: {switch: 'yes'}}) //workaround for refreshing the page and keeping path at /login.. dirty stuff...
                  
            },
            error:function(){
            try {
                    self.error = "Failed switching account"
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
      });
      },
    validateBeforeSubmit() {
      var self = this
       this.$validator.validateAll().then((result) => {
          if (self.credentials.email.substr(self.credentials.email.length-3)=="con"){
                swal("Oops, your email looks incorrect", self.credentials.email, "info")
                return;
            }
            if (result) {
                // eslint-disable-next-line
                this.submit()
                return;
            }

            swal("Something is missing", "Please complete all the required fields to continue.", "info")
        });
    },
    submit() {      
      var self = this
      $(window).scrollTop(0)
      var countryId = localStorage.getItem('CountryId')
      var credentials = {

        Email: this.credentials.email,
        FirstName: this.credentials.firstName,
        LastName: this.credentials.lastName,
        Password: this.credentials.password,
        CountryId: countryId,
        Provider: 'Direct',
        confirmPassword: this.credentials.password,
        userRole: "Sitter",
        ProfilePicUrl: ''
      }
    
      auth.register(this, credentials,'sitter-profile-edit/about')

   },
     onSignInSuccess (response) {
         var self = this
         console.log(response)
         console.log(response.data)
         self.error = ''
         self.FBTokenInfo.ProfilePicUrl = "images/sitterProfilePic.png"
          // FB.api('/me/picture?type=large', function(response){
          //    if (response.data && response.data.is_silhouette && response.data.is_silhouette==false ){
          //       self.FBTokenInfo.ProfilePicUrl = response.data.url
          //   } else
          //   {
            
          //   }
          //   });
         FB.api('/me', {fields: 'first_name,last_name,email'}, function(response) {
            self.FBTokenInfo.FirstName = response.first_name
            self.FBTokenInfo.LastName = response.last_name
            self.FBTokenInfo.Email = response.email
            localStorage.setItem('email', response.email)
            store.commit('email', localStorage.getItem('email'))
            FB.getLoginStatus(function(response) {
              self.FBTokenInfo.Token = response.authResponse.accessToken
              if (self.$route.query.redirect != null) {
                auth.fbLogin(self, self.FBTokenInfo,self.$route.query.redirect)
              } else {
                auth.fbLogin(self, self.FBTokenInfo, 'sitter-profile-edit/about')
              }
              }); 
          });
         
       },
    onSignInError (error) {
         console.log('Facebook auth error: ', error)
         this.error = "Sorry but Facebook login failed"
    },
    SignOut(response){
      FB.logout(function(response){
      })
    }
  

  },
   computed:{
      doubleRoleComp: function(){
      if (localStorage.getItem('doubleRole') == "True")
        return true
      else  
        return false
    },
    checkUserComp: function(){
      return store.getters.authenticated
    },
      filledRequired: function(){
        
         if (this.credentials.email =='' || this.credentials.password =='')
         {
           return false
         }
      },
      errorMsg: function(){
        return this.error
      },
      notificationMsg: function(){
        return this.notification
      },
      userRoleComp: function(){
        return store.getters.userRole
      },
       countryDataComp: function(){
      return store.getters.CountryData
    },
      
    },
  
  
  
}
</script>

<style scoped>



</style>


// WEBPACK FOOTER //
// SitterSignup.vue?7b02b2fe